const config = {
    API_URL: process.env.REACT_APP_API_URL,
    LIMS_API_URLS: process.env.REACT_APP_DEVELOPMENT_API_URL,
    LIMS_IMAGE_URLS: process.env.REACT_APP_DEVELOPMENT_IMAGE_URL,
    DUE_DATE_EXCEEDED_EMAILS: process.env.REACT_APP_DUE_DATE_EXCEEDED_EMAILS || 'vishnuteja16018@gmail.com,vishnuteja2022@gmail.com'
};

export default config;
